/**
 * Checks if a given date is today.
 *
 * @param date - The date to check (can be a Date object or ISO string)
 * @returns true if the date is today, false otherwise
 */
import { timeAgo } from '@art-suite/art-core-ts';

export const isDateToday = (date: Date | string): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const compareDate = new Date(date);
  compareDate.setHours(0, 0, 0, 0);
  return compareDate.getTime() === today.getTime();
};

/**
 * Formats a date as a relative time string (e.g. "5h ago", "2d ago").
 * Sub-minute results render as "Just now" (no trailing "ago").
 */
export const formatRelativeTime = (date: Date | string | number): string => {
  const result = timeAgo(date);
  if (result.toLowerCase() === 'just now') return 'Just now';
  return `${result} ago`;
};
